import { Component, inject } from '@angular/core';
import {UntypedFormControl, Validators, UntypedFormGroup} from '@angular/forms';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {ToastrService} from 'ngx-toastr';
import {Link} from '../../../models/link';
import {LinkService} from '../../../services/link.service';

@Component({
    selector: 'app-team-member-modal',
    templateUrl: './link-modal.component.html',
    standalone: false
})
export class LinkModalComponent {
    private linkService = inject<LinkService>('LinkService' as any);
    modalRef = inject(VwuiModalRef);
    private toast = inject(ToastrService);
    private modalConfig = inject<VwuiModalConfig<{
    refId: number;
    link?: Link;
}>>(VwuiModalConfig);


    form = new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
        link: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
        type: new UntypedFormControl(null, [Validators.required]),
    });

    saving = false;
    refId: number | undefined = 0;
    link: Link | undefined = undefined;
    action = 'toevoegen';

    constructor() {
        const modalConfig = this.modalConfig;

        this.refId = modalConfig.data?.refId;
        this.link = modalConfig.data?.link;

        if (this.link) {
            this.action = 'bijwerken';
            this.form.patchValue(this.link);
        }
    }

    async saveLink(): Promise<void> {
        if (this.form.invalid || this.saving) {
            return;
        }

        if (!this.refId) {
            return;
        }

        const existingLink = !!this.link;
        try {
            this.saving = true;
            if (existingLink) {
                await this.linkService.update(this.refId, this.form.value).toPromise();
            } else {
                await this.linkService.create(this.refId, this.form.value).toPromise();
            }
            this.modalRef.close();
        } catch (e) {
            console.error(`Error while  ${existingLink ? 'updating' : 'adding'} a link`, e);
            this.toast.error(`Er is iets misgegaan bij het  ${this.action} van het document`);
        } finally {
            this.saving = false;
        }

    }

}
